// Retrospective status values
export const RetroStatus = {
    DRAFT: "DRAFT",
    ACTIVE: "ACTIVE",
    COMPLETED: "COMPLETED",
};
/**
 * The reactions a note can carry.
 *
 * A fixed set rather than a free picker: it keeps the board legible, bounds
 * what can be stored, and lets the server reject anything else outright.
 *
 * Note what is *stored* is the ASCII `key`, never the glyph. MySQL's
 * utf8mb4_unicode_ci collation treats many emoji as equal — '👍' = '🎉' is
 * true — so an emoji-keyed unique constraint would collapse every reaction
 * into one. Keys also survive changing a glyph later without a data migration.
 */
export const REACTIONS = [
    { key: "thumbs_up", emoji: "👍" },
    { key: "heart", emoji: "❤️" },
    { key: "party", emoji: "🎉" },
    { key: "joy", emoji: "😂" },
    { key: "wow", emoji: "😮" },
    { key: "thinking", emoji: "🤔" },
];
export function isReactionKey(value) {
    return (typeof value === "string" &&
        REACTIONS.some((reaction) => reaction.key === value));
}
export function emojiForReaction(key) {
    return REACTIONS.find((reaction) => reaction.key === key)?.emoji ?? key;
}
/**
 * Post-it geometry, shared so the client's clamping and the server's agree.
 * A note that one of them would accept and the other would silently rewrite
 * is a note that jumps under your cursor after the round trip.
 */
export const NOTE_SIZE = {
    defaultWidth: 208,
    defaultHeight: 168,
    minWidth: 132,
    minHeight: 96,
    maxWidth: 560,
    maxHeight: 640,
};
/** How far a note may sit from its canvas's top-left corner. */
export const NOTE_CANVAS = {
    maxX: 4000,
    maxY: 8000,
};
export function clampNoteWidth(width) {
    return Math.min(NOTE_SIZE.maxWidth, Math.max(NOTE_SIZE.minWidth, width));
}
export function clampNoteHeight(height) {
    return Math.min(NOTE_SIZE.maxHeight, Math.max(NOTE_SIZE.minHeight, height));
}
//# sourceMappingURL=types.js.map